<script lang="ts">
  import { slide } from 'svelte/transition';
  import Default from './Default.svelte';
  import Close from '$icons/CloseAltIcon.svelte';
  import Loader from '$icons/LoaderIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  import Warning from '$icons/WarningIcon.svelte';
  import Input from '$lib/components/common/inputs/textInputs/GlobalTextInput.svelte';
    import Button from '../buttons/Button.svelte';

  export let label = '';
  export let caption = '';
  export let value;
  export let options: string[] = [];
  export let placeholder = '';
  export let danger: boolean = false;
  export let dangerMessage: string = '';
  export let createNewDisable = false;
  export let inComponentLogic: boolean = false;

  let selectedValuesBuffer = [];

  let dropdownOpen = false;
  let inputFocused = false;

  let loading = false;
  let addMode = false;
  let dispatch = createEventDispatcher();

  $: {
    if (!inputFocused) {
      addMode = false;
    }
  }

  // ----------- search ------------

  $: filteredOptions = options.filter(option => {
    return option?.toLowerCase()?.includes(value?.toLowerCase());
  });

  const searchValue = option => {
    value = option;
  };

  // ----------- for add mode ------------

  let addModeInputCaption = 'Caption goes here';
  let addModeInputValue = '';

  // -------------------------------------

  $: {
    dispatch('change', { value, selectedValuesBuffer });
  }
</script>

<Default
  bind:label
  bind:caption
  bind:placeholder
  bind:danger
  bind:dangerMessage
  bind:dropdownOpen
  bind:inputFocused
  bind:value
  bind:selectedValuesBuffer
  notReadOnly
  on:submit={() => {
    // to prevent options from being selected when the user presses enter
    selectedValuesBuffer = [];
  }}
  class={$$props.class}
>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    slot="icon"
    on:click={() => {
      value = '';
    }}
    on:keydown
  >
    {#if value}
      <Close />
    {/if}
  </div>

  {#if !loading}
    {#if addMode}
      <div
        class="p-4 -mt-7 flex flex-col items-center gap-3"
        transition:slide|global={{ duration: 100 }}
      >
        <Input
          autofocus
          label=""
          bind:caption={addModeInputCaption}
          bind:value={addModeInputValue}
        />
        <div
          class="border-t border-[#F2F4F7] w-full flex flex-row items-center justify-between pt-3"
        >
          <div class="flex flex-row gap-2">
            <Button
              primary
              xs
              label="Create"
              on:click={() => {
                dispatch('create', addModeInputValue);
                if (inComponentLogic) options.push(addModeInputValue);
                loading = true;
                setTimeout(() => {
                  loading = false;
                  addMode = false;
                }, 150);
              }}
            />
            <Button
              secondary
              xs
              label="Cancel"
              on:click={() => {
                loading = true;
                setTimeout(() => {
                  loading = false;
                  addMode = false;
                }, 150);
              }}
            />
          </div>
          <span class="text-xs text-garden-grey-400">
            {addModeInputValue.length}/50
          </span>
        </div>
      </div>
    {:else}
      {#each filteredOptions as option}
        <div
          class="flex flex-row items-center border-y hover:border-[#F2F4F7] border-white px-4 py-3 cursor-pointer text-garden-grey-700"
          on:keydown
          on:click|stopPropagation={() => {
            dropdownOpen = false;
            inputFocused = false;

            value = option;
          }}
          transition:slide|global={{ duration: 100 }}
        >
          {option}
        </div>
      {:else}
        <div>
          <div
            class="flex flex-col items-center justify-center gap-3 pb-7 pt-6 border-b border-[#F2F4F7]"
          >
            <Warning />
            <span class="text-garden-grey-600 text-sm font-semibold"> No more results found </span>
          </div>

          <div class="flex flex-col justify-center gap-2 py-3">
            <span class="text-grey-transparency-dark-56 text-xs font-normal text-center">Try searching for</span>
            <div class="flex flex-row gap-2 justify-center items-center">
              {#each [options[Math.floor(Math.random() * options.length)], options[Math.floor(Math.random() * options.length)], options[Math.floor(Math.random() * options.length)]] as i}
                <div
                  class="py-1 px-3 text-garden-grey-700 flex text-xs border border-dashed border-garden-grey-300 rounded-[32px] cursor-pointer"
                  on:keydown
                >
                  {i}
                </div>
              {/each}
            </div>
          </div>
        </div>
      {/each}
      {#if filteredOptions.length && !createNewDisable}
        <div
          class="border-t border-garden-grey-200 text-brand-green font-semibold text-sm px-4 py-3 cursor-pointer flex flex-row items-center gap-3"
          on:click={() => {
            loading = true;
            setTimeout(() => {
              loading = false;
              addMode = true;
            }, 150);
          }}
          on:keydown
          transition:slide|global={{ duration: 100 }}
        >
          <span class=" rotate-45"><Close color="#0F9D58" /></span> Add new
        </div>{/if}
    {/if}
  {:else}
    <div class="flex items-center justify-center py-5" transition:slide|global={{ duration: 100 }}>
      <Loader size="38" />
    </div>
  {/if}
</Default>
